import LoginForm from "@/components/auth/LoginForm";
import RegisterForm from "@/components/auth/RegisterForm";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function Login() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
      <Card className="w-full max-w-md mx-auto shadow-lg">
        <CardHeader className="space-y-2 text-center pb-6">
          <CardTitle className="text-2xl font-heading font-bold text-primary">
            ImobControl
          </CardTitle>
          <p className="text-sm text-muted-foreground">
            Entre ou cadastre-se para acessar o sistema
          </p>
        </CardHeader>
        <CardContent>
          <Tabs defaultValue="register" className="space-y-6">
            <TabsList className="grid w-full grid-cols-2 gap-4">
              <TabsTrigger value="register" className="text-base">
                Cadastrar
              </TabsTrigger>
              <TabsTrigger value="login" className="text-base">
                Entrar
              </TabsTrigger>
            </TabsList>
            <TabsContent value="register" className="space-y-4">
              <RegisterForm />
            </TabsContent>
            <TabsContent value="login" className="space-y-4">
              <LoginForm />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
}